export const API_BASE_URL = process.env.API_BASE_URL;
export const SHOP_URL = 'https://animalpride.com/collections/dfwlrrc?ref=ApDfwlrrc'